<div class="ppl-main-fullwidth mb-5">
  <div class="card">
    <p-table #dt2 [value]="filteredData" [(selection)]="selectedCheckBoxValue" [paginator]="isPaginationVisible()"
      [rows]="pageSize" [columns]="cols" [exportHeader]="'customExportHeader'" [(first)]="first"
      [tableStyle]="{ 'min-width': tableWidth ? tableWidth:'50rem'}" [scrollable]="tableScrollable"
      [scrollHeight]="tableScrollHeight" [globalFilterFields]="globalFilterField" [alwaysShowPaginator]="false"
      [totalRecords]="totalRecords || filteredData.length" (onLazyLoad)="loadRecords($event)"
      (selectionChange)="onSelectionChange()" (onSort)="sortByColumn($event)" (onFilter)="onColumnFilter($event)"
      (onHeaderCheckboxToggle)="selectAll($event)" [lazy]="loadPage" styleClass="p-datatable-striped">
      @if(!disableSearch){
      <ng-template pTemplate="caption">
        <div style="display: flex; justify-content: space-between;">
          <div class="table-header-action-container">
            <!-- <div style="position: relative; width: 45% !important">
              <p-iconField iconPosition="right" class="ml-auto">
                <input #inputRef display="menu" pInputText type="text" class="global-search" title="Filter results"
                  (input)="onSearch($any($event.target).value)" [(ngModel)]="gridTextSearchFilter"
                  placeholder="Filter" />
              </p-iconField>
               <div class="filter-panel">
                  
                  <div></div>
              </div> -->
            @if(showCustomSearch){
            <ppl-button ariaLabel="Custom search" label="Custom Search" icon="fa fa-filter"
              [customClass]="'primary-button'" [iconPosition]="'left'" (click)="show = true"></ppl-button>
            }
            <ppl-button ariaLabel="Download" label="" icon="fa fa-download" [customClass]="'primary-button'"
              [iconPosition]="'left'" (click)="exportAllCSV()"></ppl-button>
            <ppl-button ariaLabel="Refresh" label="" icon="fa fa-refresh" [customClass]="'primary-button'"
              [iconPosition]="'left'" (click)="onCancel()"></ppl-button>
            <!-- <p-inputIcon (click)="filterpanel.toggle($event)">
              <div class="filter-btn custom-search-btn" [ngClass]="{'primary-bgclr': isFilterApplied, 'hammer-btn': !isFilterApplied}">
                <i class="pi pi-filter"></i>&nbsp;
                <span class="filter-text"><b>Custom Search</b></span>
              </div>
            </p-inputIcon> -->
            <!-- <p-inputIcon (click)="dt2.exportCSV()">
              <i class="pi pi-file-excel hammer-btn"></i>
            </p-inputIcon> -->
            <!-- <p-inputIcon (click)="onCancel()">
              <i class="pi pi-refresh hammer-btn"></i>
            </p-inputIcon> -->
          </div>
          <div class="row-buttons-container">
            <!-- <div class="custom-row m-0">
              <span nz-icon nzType="message" nzTheme="outline" class="mr-2" (click)="sendSMS()"></span>
              <span nz-icon nzType="mail" nzTheme="outline" class="mr-2"></span>
            </div> -->
            <div class="actGRP">
              <!-- <img src="../../assets/images/sms_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24.svg" height="32px" (click)="sendNotification('sms')">
          <img class="ico" src="../../assets/images/mail_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24.svg" (click)="sendNotification('email')" height="32px"> -->
              @if(showSelectAction){
              <ppl-actions [listButton]="listButton" [selectedCheckBoxValue]="selectedCheckBoxValue"
                [sourcePage]="jsonList" (leadUpdated)="leadUpdated($event)" [from]="'list'"></ppl-actions>
              }
              <div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      } @else if (enablePageActions) {
      <ng-template pTemplate="caption">
        <div style="display: flex; justify-content: end;">
          <div class="row-buttons-container">
            <div class="actGRP">
              @if(showSelectAction){
              <ppl-actions [listButton]="listButton" [selectedCheckBoxValue]="selectedCheckBoxValue"
                [sourcePage]="jsonList || timesheetFor" (leadUpdated)="leadUpdated($event)"
                (actionInvoked)="actionInvoked.emit($event)" [from]="'list'"></ppl-actions>
              }
              <div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      }
      <ng-template pTemplate="header" let-columns>
        <tr>
          @if(!disableSelection){
          <th style="width: 4rem; padding-top: 1px; background-color: #a8e4e14d;">
            <div nz-tooltip [nzTooltipTitle]="'Select all'" nzTooltipPlacement="topRight">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </div>
          </th>
          }
          @if(showExpandIcon){
          <th style="width: 3rem; background-color: #a8e4e14d;"></th>
          }

          @for ( col of columns ; track col; let idx = $index ) {

          @if(disableSort){
          <th style="text-wrap: nowrap; background-color:#a8e4e14d;">
            <div [innerHTML]="col.header | newlineToBr"></div>
          </th>
          }

          @if(!disableSort){
          <th [pSortableColumn]="col.field" style="background-color:#a8e4e14d;">


            <div class="filter-item" [class.last-th]="idx === columns?.length - 1">
              <div [innerHTML]="col.header | newlineToBr"></div>
              <div>
                <p-sortIcon [field]="col.field"></p-sortIcon>
                <!-- <p-columnFilter type="text" [field]="col.field" display="menu" /> -->
              </div>
            </div>
          </th>
          }
          } @if(enableActions){
          <th style="background-color:#a8e4e14d;">
            <div>Actions</div>
          </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData" [class.ppl-row-highlight]="rowData?.isHighlighted">

          @if(!disableSelection){
            <td class="check-box" *ngIf="!disableSelection">
              @if (selectionDisabler?.(rowData) === true) {
              <span class="ppl-row-disabled" title="Already acknowledged">
                <i class="fa fa-lock" aria-hidden="true"></i>
              </span>
              } @else {
              <p-tableCheckbox [value]="rowData" [ariaLabel]="rowData[rowDataAccessibilityKey] || 'Select row'"
                [disabled]="disableSelection || selectionDisabler?.(rowData) === true">
              </p-tableCheckbox>
              }
            </td>
          }
          @if(showExpandIcon){
          <td class="expand-row" style="padding-left: 30px;" (click)="rowClicked(rowData, null)">
            <button class="expand-row-icon-btn" aria-label="Expand Row">
              <i [class]="rowData.showLineItem ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
            </button>
          </td>
          }
          @if(!data.length){
          @for (record of filterHeaders; track $index) {
          @if($first){
          <td (click)="rowClicked(rowData, record.jsonpath)" [ngClass]="{'table-data-first-column': highlightFirst}">
            <a 
            [attr.tabindex]="validateFieldHasValue(rowData[record.jsonpath]) ? 0 : null"
            href="#"
            (click)="rowLinkClicked($event)"
            class="table-data-first-column"
          >
            {{ (rowData[record.jsonpath] | booleanYesNo) || '-' }}
            </a>
          </td>
          }@else {
          <td (click)="record.jsonpath === 'ignoredTimesheetCount' ? rowClicked(rowData, record.jsonpath) : null"
            (dblclick)="from !== 'billing' && rowClicked(rowData, record.jsonpath)" class="table-data"
            [ngClass]="{'table-data-first-column': record.jsonpath === 'ignoredTimesheetCount' && rowData[record.jsonpath]}">
            <span tabindex="0" role="text" *ngIf="!(rowData[record.jsonpath] | booleanYesNo); else normalValue" aria-label="blank">
            <span aria-hidden="true">
              {{ '-' }}
            </span>
            </span>
            <ng-template #normalValue>
              <span tabindex="0">
                {{ rowData[record.jsonpath] | booleanYesNo }}
              </span>
            </ng-template>
          </td>
          }
          }
          }

          @if(data.length){
          @for ( col of columns ; track col ) {
          @if($first && rowData.highlightLabel){
          <td class="table-data" (click)="rowClicked(rowData, col)" [ngClass]="{'prospective': disableSort}">
            <span tabindex="0">{{ rowData[col.field] }}</span>
            <span class="ppl-row-pill">{{ rowData.highlightLabel }}</span>
          </td>
          }
          @else if(col.header === 'Message'){
          <td class="table-data" (click)="rowClicked(rowData, col)" [ngClass]="{'prospective': disableSort}">
            <span tabindex="0">{{ rowData[col.field] }}</span>
          </td>
          }
          @else if (col.field === 'timeIn' || col.field === 'timeOut') {
          <td class="table-data" (click)="rowClicked(rowData, col)"
            [ngClass]="{'prospective': disableSort}">
            <span tabindex="0">{{ rowData[col.field] | timeFormat }}</span>
          </td>
          }
          @else if (col.field === 'carcReasonCode' || col.field === 'rarcReasonCode') {
          <td class="table-data hyperlink" (click)="rowClicked(rowData, col)" [ngClass]="{'prospective': disableSort}">
            @if (rowData[col.field] !== null) {
            <ng-template #contentTemplate>
              <div>
                <p>{{col.field === 'carcReasonCode' ? rowData.carcReasonCodeDesc : rowData.rarcReasonCodeDesc}}</p>
              </div>
            </ng-template>
            <button nz-button nzType="text" style="color: blue;" nz-popover [nzPopoverContent]="contentTemplate"
              nzPopoverTrigger="click">{{ rowData[col.field] }}</button>
            }
          </td>
          }
          @else if(from === 'netLedger' && col.field === 'category'){
            <td class="table-data category-cell" [ngClass]="'category-cell--' + (rowData[col.field] | lowercase)">
              <span class="category-badge" [ngClass]="'category-badge--' + (rowData[col.field] | lowercase)">
                {{ rowData[col.field] }}
              </span>
            </td>
          }
          @else if(from === 'netLedger' && col.field === 'event'){
            <td class="table-data">
              <div class="net-ledger-event">
                <span class="net-ledger-event__title">{{ rowData.eventTitle }}</span>
                <span class="net-ledger-event__note">{{ rowData.eventNote }}</span>
              </div>
            </td>
          }
          @else if(from === 'netLedger' && col.field === 'claim'){
            <td class="table-data">
              @if (rowData.isCurrentClaim) {
                <span class="net-ledger-claim net-ledger-claim--current">{{ rowData.claimIcn }} (Current)</span>
              } @else {
                <button type="button" class="net-ledger-claim-link"
                  (click)="rowDetailEventTs.emit({ event: rowData, col: col })">{{ rowData.claimIcn }}</button>
              }
            </td>
          }
          @else if(from === 'netLedger' && col.field === 'credit'){
            <td class="table-data credit-cell" [class.credit-cell--value]="rowData.creditPositive">
              {{ rowData[col.field] }}
            </td>
          }
          @else if(col.field === 'depositMatched'){
            <td class="table-data ctr">
              <span class="deposit-pill" [class.deposit-pill--yes]="rowData[col.field] === 'YES'"
                [class.deposit-pill--no]="rowData[col.field] !== 'YES'">
                {{ rowData[col.field] }}
              </span>
            </td>
          }
          @else if(col.field === 'utilizationPct'){
            <td class="table-data">
              <span class="util-cell" [ngClass]="'util-cell--' + rowData.utilizationBand">
                <span class="util-cell__pct">{{ rowData.utilizationPctLabel ?? (rowData.utilizationPct | number: '1.1-1') }}%</span>
                <span class="util-cell__bar"><i [style.width.%]="rowData.utilizationPct < 100 ? rowData.utilizationPct : 100"></i></span>
              </span>
            </td>
          }
          @else if(col.field === 'isAdvanceDepositPill'){
            <td class="table-data ctr">
              <span class="advance-pill" [class.advance-pill--yes]="rowData[col.field] === 'YES'"
                [class.advance-pill--no]="rowData[col.field] !== 'YES'">
                {{ rowData[col.field] }}
              </span>
            </td>
          }
          @else if(col.field === 'arAmount' && rowData.arAmountClass){
            <td class="table-data" [ngClass]="'ar-amount--' + rowData.arAmountClass">
              {{ rowData[col.field] }}
            </td>
          }
          @else if(col.field === 'status' && rowData.statusClass){
            <td class="table-data">
              <span class="status-pill" [ngClass]="'status-pill--' + rowData.statusClass">
                {{ rowData[col.field] }}
              </span>
            </td>
          }
          @else if(col.field === 'source' && rowData.sourceBadgeClass){
            <td class="table-data category-cell" [ngClass]="'category-cell--' + rowData.sourceBadgeClass">
              <span class="category-badge" [ngClass]="'category-badge--' + rowData.sourceBadgeClass">
                {{ rowData[col.field] }}
              </span>
            </td>
          }
          @else if(col.field === 'canSubmitTimesheet'){
            <td>
              <i 
                class="fa"
                [ngClass]="{
                  'fa-check-circle text-success': rowData[col.field],
                  'fa-times-circle text-danger': !rowData[col.field]
                }"
                aria-hidden="true"
              ></i>
            </td>
          }
          @else {
          <td class="table-data"
            (click)="from !== 'billing' || isClickableInBilling(rowData, col.field) ? rowClicked(rowData, col) : null"
            (keydown)="from !== 'billing' || isClickableInBilling(rowData, col.field) ? keyPressed($event,rowData, col) : null"
            [ngClass]="{
              'prospective': disableSort,
              'bold-text': boldFirstRow && rowIndex === 0
            }">
            <ng-container *ngIf="col.field === 'isVerified'">
              {{ rowData.isVerified ? 'Yes' : 'No' }}
            </ng-container>
            <ng-container *ngIf="col.field !== 'isVerified'">
              <span [ngStyle]="getCellStyles(rowData, col)" class="hyperlink">
                <span 
                [attr.tabindex]="validateFieldHasValue(rowData[col.field]) ? 0 : null"
                *ngIf="col.field === 'chequeNumber'">
                  {{ rowData[col.field] }}
                  @if (rowData[col.field]) {
                  <span>(</span><span class="table-data-first-column" (click)="actionType('paystub')">View Paystub, 
                  </span><span class="table-data-first-column" (click)="actionType('download')">Download</span><span>)</span>
                  }
                </span>

                @if(col.field !== 'chequeNumber' && col.isClickable) {
                  <a tabindex="0"> {{ rowData[col.field] }} </a>
                }
                @else if (col.field !== 'chequeNumber' && isClickableField(rowData, col)) {
                  <a tabindex="0"> {{ rowData[col.field] }} </a>
                }
                @else if (col.field !== 'chequeNumber') {
                  <span tabindex="0" role="text" *ngIf="!(rowData[col.field]); else normalValue" aria-label="blank">
                    <span aria-hidden="true">{{ '-' }}</span>
                  </span>
                  <ng-template #normalValue>
                    <span tabindex="0">
                      {{ rowData[col.field] }}
                  </span>
                </ng-template>
            }
            </span>
            </ng-container>
          </td>
          }
          }
          }

          @if(enableActions){
          <td>
            <div class="action-item">
              <div class="action-container">
                @if(actionButtons?.edit
                && (rowData?.type !== 'Social Security Number (SSN)' || (rowData?.type === 'Social Security Number (SSN)' && rowData?.canEditSSN))
                && (!isVerifiedFlag || (isVerifiedFlag && !rowData.isVerified)) ||
                rowData.actions?.edit || (from === 'additional_attributes' && !rowData.is_read_only && rowData.canEdit !== false)){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Edit' : 'Edit'" label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="gridActionClicked('edit', rowData)" [disabled]="rowData?.disable"></ppl-button>
                }
                @if(actionButtons?.verify && (!isVerifiedFlag || (isVerifiedFlag && !rowData.isVerified)) ||
                rowData.actions?.verify){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Edit and verify' : 'Edit and verify'" label="Edit & Verify" icon="fa fa-pencil"
                  [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="gridActionClicked('verify', rowData)"></ppl-button>
                }

                @if(actionButtons?.view && rowData?.actions?.view !== false){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' View' : 'View'" label="View" icon="fa fa-eye" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="gridActionClicked('view', rowData)"></ppl-button>
                }

                @if(actionButtons?.download){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Download' : 'Download'" label="Download" icon="fa fa-download" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="gridActionClicked('download', rowData)"></ppl-button>
                }

                @if(actionButtons?.delete || rowData.actions?.delete || (from === 'additional_attributes' &&
                !rowData.is_read_only)){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Delete' : 'Delete'" label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="gridActionClicked('delete', rowData)" [disabled]="rowData?.disableDelete"></ppl-button>
                }

                @if(actionButtons?.viewPdf){
                <span nz-tooltip="View Image">
                  <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' View Image' : 'View Image'" label="" icon="fa fa-file-pdf-o" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" (click)="gridActionClicked('viewPdf', rowData)">
                  </ppl-button>
                </span>
                }

                @if(actionButtons?.viewClaimReport){
                <span nz-tooltip="View File Data">
                  <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' View File Data' : 'View File Data'" label="" icon="fa fa-file-alt" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" (click)="gridActionClicked('viewClaimReport', rowData)">
                  </ppl-button>
                </span>
                }

                @if(actionButtons?.viewCDR){
                <span nz-tooltip="View CDR">
                  <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' View CDR' : 'View CDR'" label="" icon="fa fa-balance-scale" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" (click)="gridActionClicked('viewCDR', rowData)">
                  </ppl-button>
                </span>
                }

                @if(actionButtons?.viewPayment){
                <span nz-tooltip="View Payment">
                  <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' View Payment' : 'View Payment'" label="" icon="fa fa-credit-card" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" (click)="gridActionClicked('viewPayment', rowData)">
                  </ppl-button>
                </span>
                }

                @if(actionButtons?.viewHierarchy ){
                <span nz-tooltip="View Hierarchy ">
                  <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' View Hierarchy' : 'View Hierarchy'" label="" icon="fa fa-sitemap" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" (click)="gridActionClicked('viewHierarchy', rowData)">
                  </ppl-button>
                </span>
                }

                @if(rowData.actions?.showDisassociate){
                  <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Remove' : 'Remove'" label="Remove" icon="fa fa-trash" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="gridActionClicked('disassociate', rowData)"></ppl-button>
                }

                @if(actionButtons?.add){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Add' : 'Add'" label="Add" icon="fa fa-plus" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="gridActionClicked('add', rowData)"></ppl-button>
                }

                @if(actionButtons?.cancel || rowData.actions?.cancel){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Cancel' : 'Cancel'" label="Cancel" icon="fa fa-trash" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="gridActionClicked('cancel', rowData)"></ppl-button>
                }

                @if(actionButtons?.refresh){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Refresh' : 'Refresh'" label="Refresh" icon="fa fa-refresh" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="gridActionClicked('refresh', rowData)"></ppl-button>
                }

                @if(rowData.actions?.showStatus){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Manage Status' : 'Manage Status'" label="Manage Status" icon="fa fa-briefcase"
                  [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="gridActionClicked('showStatus', rowData)"></ppl-button>
                }

                @if(rowData.actions?.manageConsumer){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Manage Consumer' : 'Manage Consumer'" label="Manage Consumer" icon="fa fa-briefcase"
                  [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="gridActionClicked('manageConsumer', rowData)"></ppl-button>
                }

                @if(rowData.actions?.aorWaiver){
                  <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' AOR' : 'AOR'" label="AOR" icon="fa fa-briefcase"
                    [customClass]="'ghost-button'" [iconPosition]="'left'"
                    (click)="gridActionClicked('aorWaiver', rowData)"></ppl-button>
                }

                @if(rowData.actions?.moveToPPLReview){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Move to PPL review' : 'Move to PPL review'" label="Move To PPL Review" icon="fa fa-arrow-circle-right"
                  [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="gridActionClicked('moveToPPLReview', rowData)"></ppl-button>
                }

                @if(actionButtons?.approve || rowData.actions?.approve){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Approve' : 'Approve'" label="Approve" [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="gridActionClicked('approve', rowData)" [disabled]="from === 'associations' && (rowData.disabled || rowData.isAssocApproved === true)"></ppl-button>
                }

                @if(rowData.actions?.reject){
                  <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Reject' : 'Reject'" label="Reject" [customClass]="'ghost-button'" [iconPosition]="'left'"
                    (click)="gridActionClicked('reject', rowData)" [disabled]="rowData.disabled || rowData.isAssocApproved === false"></ppl-button>
                }

                @if(actionButtons?.select){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Select' : 'Select'" label="Select" [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="gridActionClicked('select', rowData)"></ppl-button>
                }

                @if(actionButtons?.deny || rowData.actions?.deny){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Deny' : 'Deny'" label="Deny" [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="gridActionClicked('deny', rowData)"></ppl-button>
                }

                @if(actionButtons?.mail && !isCreationFlow){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Mail' : 'Mail'" label="Mail" icon="fa fa-envelope" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="gridActionClicked('requestMail', rowData)"></ppl-button>
                }
                @if((actionButtons?.history && rowData?.hideHistory !== true) || rowData.actions?.history){
                  <ppl-button 
                    [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' History' : 'History'" 
                    label="History" 
                    icon="fa fa-history" 
                    [customClass]="'ghost-button'" 
                    [iconPosition]="'left'" 
                    (click)="gridActionClicked('history', rowData)">
                  </ppl-button>
                }
                @if(rowData.actions?.block || rowData.actions?.unblock){
                  <ppl-button
                    [ariaLabel]="rowData.actions?.block ? (rowData.actions?.blockLabel || 'Block') : (rowData.actions?.unblockLabel || 'Unblock')"
                    [label]="rowData.actions?.block ? (rowData.actions?.blockLabel || 'Block') : (rowData.actions?.unblockLabel || 'Unblock')"
                    [icon]="rowData.actions?.block ? 'fa fa-ban' : 'fa fa-unlock'"
                    [customClass]="'ghost-button'"
                    [iconPosition]="'left'"
                    [disabled]="rowData?.isSsnBlockedOnAll"
                    (click)="gridActionClicked(rowData.actions?.block ? 'block' : 'unblock', rowData)">
                  </ppl-button>
                }
                @if(rowData.actions?.freeze || rowData.actions?.unfreeze){
                  <ppl-button
                    [ariaLabel]="rowData.actions?.freeze ? 'Freeze changes' : 'Unfreeze changes'"
                    [label]="rowData.actions?.freeze ? 'Freeze' : 'Unfreeze'"
                    [icon]="rowData.actions?.freeze ? 'fa fa-lock' : 'fa fa-unlock'"
                    [customClass]="'ghost-button'"
                    [iconPosition]="'left'"
                    (click)="gridActionClicked(rowData.actions?.freeze ? 'freeze' : 'unfreeze', rowData)">
                  </ppl-button>
                }
                @if(rowData.actions?.exclude || rowData.actions?.revert){
                  <ppl-button
                    [ariaLabel]="rowData.actions?.exclude ? (rowData.actions?.excludeLabel || 'Exclude') : (rowData.actions?.revertLabel || 'Revert Exclusion')"
                    [label]="rowData.actions?.exclude ? (rowData.actions?.excludeLabel || 'Exclude') : (rowData.actions?.revertLabel || 'Revert Exclusion')"
                    [icon]="rowData.actions?.exclude ? 'fa fa-ban' : 'fa fa-undo'"
                    [customClass]="'ghost-button'"
                    [iconPosition]="'left'"
                    (click)="gridActionClicked(rowData.actions?.exclude ? 'exclude' : 'revertExclusion', rowData)">
                  </ppl-button>
                }
                @if(actionButtons?.return && ([44, 39, 41].includes(rowData.formMasterId)) && !isCreationFlow){
                <ppl-button 
                    [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Return' : 'Return'" 
                    label="Return Form" 
                    icon="fa fa-reply" 
                    [customClass]="'ghost-button'" 
                    [iconPosition]="'left'" 
                    (click)="gridActionClicked('return', rowData)"
                    [disabled]="rowData.formStatus !== 'C'">
                  </ppl-button>
                }
                @if(actionButtons?.showChanges && rowData?.actions?.showChanges !== false){
                  <ppl-button
                    [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Show Changes' : 'Show Changes'"
                    label="Show Changes" 
                    icon="fa fa-download" 
                    [customClass]="'ghost-button'" 
                    [iconPosition]="'left'" 
                    (click)="gridActionClicked('showChanges', rowData)"
                    [disabled]="false">
                  </ppl-button>
                }

                @if(actionButtons?.schedule && ((!rowData?.value.toLowerCase().includes('pass') && !rowData?.value.toLowerCase().includes('fail')) || rowData?.value.toLowerCase().includes('expire'))){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Schedule' : 'Schedule'" label="Schedule" icon="fa fa-thin fa-calendar"
                  [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="gridActionClicked('schedule', rowData)"></ppl-button>
                }
                @if(rowData.timeOff && rowData.timeOff > 0){
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' Timeoff' : 'Timeoff'" label="Timeoff ({{rowData.timeOff}})" icon="fa fa-eye"
                  [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="gridActionClicked('timeoff', rowData)"></ppl-button>
                }

                @if(actionButtons?.unmask && rowData?.type === 'Social Security Number (SSN)' && rowData?.value.startsWith('XXX-XX'))
                {
                  <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' UnMask' : 'UnMask'" label="UnMask" icon="fa fa-eye" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="gridActionClicked('unmask', rowData)">
                  </ppl-button>
                }
                @if(buttonConfig?.length) {
                  @for (btn of buttonConfig; track $index) {
                    @if(btn.condition(rowData)) {
                      <ppl-button 
                        [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' ' + btn.label : btn.label"
                        [label]="btn.label(rowData)"
                        [icon]="btn.icon"
                        [customClass]="'ghost-button ' + (from === 'claimsAdjustment' ? 'claim-button' : '')"
                        [iconPosition]="'left'"
                        [disabled]="btn.disabled(rowData)"
                        (click)="gridActionClicked(btn.key, rowData)">
                      </ppl-button>
                    }
                  }
                }
              </div>
            </div>
          </td>
          }
        </tr>
        @if(showLineItem && rowData.showLineItem) {
        @if(rowData?.lineItems?.length > 0) {
        <tr style="background: #fff !important; border: 1px solid #e2f4f3;">
          <td></td>
          <td [attr.colspan]="lineItemCols.length + 1 >= 10 ? lineItemCols.length + 1 : 10">
            <p-table #dtLineItem [value]="rowData.lineItems" [columns]="lineItemCols" styleClass="line-item-table">
              <ng-template pTemplate="header" let-ncolumns>
                <tr>
                  @for ( ncol of ncolumns ; track ncol; ) {
            <th style="text-wrap: nowrap; padding-left: 20px !important;">
              {{ ncol.header }}
            </th>
            }
            @if (from !== 'billing' && showLineItemActions) {
            <th style="text-wrap: nowrap; padding-left: 20px !important;">
              Actions
            </th>
            }
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-nrowData let-ncolumns="columns">
        <tr [pSelectableRow]="rowData" style="background: #fff !important; ">
          @if(rowData.lineItems.length > 0){
          @for ( ncol of ncolumns ; track ncol ) {
          <td class="table-data" [ngClass]="{'prospective': disableSort}" 
          (click)="rowClicked(nrowData, ncol)"
          (keydown)="keyPressed($event, nrowData, ncol)">
            @if(ncol.isClickable) {
              <a tabindex="0"> {{ nrowData[ncol.field] }} </a>
            }
            @else if(ncol.field === 'processingStatus') {
              <span tabindex="0">{{ nrowData[ncol.field] }}</span>
            }
            @else {
              <span tabindex="0" [ngStyle]="getCellStyles(nrowData, ncol)" class="hyperlink">
                {{ nrowData[ncol.field] }}
              </span>
            }
          </td>

          }
          @if (from !== 'billing' && showLineItemActions) {
          <td>
            <div class="action-item">
              <div class="action-container">
                <ppl-button [ariaLabel]="rowData?.arialabel ? rowData.arialabel + ' View' : 'View'" label="View" icon="fa fa-eye" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="gridActionClicked('view', nrowData, rowData)"></ppl-button>
              </div>
            </div>
          </td>
          }
          }
        </tr>
      </ng-template>
    </p-table>
    </td>
    </tr>
    } @else {
    <tr style="background: #fff !important; border: 1px solid #e2f4f3;">
      <td></td>
      <td [attr.colspan]="lineItemCols.length + 1">
        <p tabindex="0" class="error-message pt-2">No timesheets found for this {{from === 'billing' ? 'claim Id' : ' pay period.'}}
        </p>
      </td>
    </tr>
    }
    }
    @if(showLineItem && rowData.additionalData && rowData.additionalData?.length ) {
    <tr>
      <td [attr.colspan]="additionalCols?.length" style="padding: 7px 0px;">
        <p-table #dtLineItem [value]="rowData.additionalData" [columns]="additionalCols" styleClass="line-item-table">
          <ng-template pTemplate="header" let-ncolumns>
            @for ( ncol of ncolumns ; track ncol; ) {
      <th style="text-wrap: nowrap; padding-left: 20px !important;">
        {{ ncol.header }}
      </th>
      }
      </ng-template>
      <ng-template pTemplate="body" let-nrowData let-ncolumns="columns">
    <tr [pSelectableRow]="rowData" style="background: #fff !important; ">
      @if(rowData.additionalData?.length > 0){
      @for ( ncol of ncolumns ; track ncol ) {
      <td class="table-data" [ngClass]="{'table-data-first-column': $first && ncol.field === 'clientAuthNumber'}"
        style="text-wrap: nowrap; padding-left: 20px !important;" (click)="showDetails(nrowData)">
          <ng-container>
            {{ nrowData[ncol.field] }}
          </ng-container>
      </td>
      }
      }
    </tr>
    </ng-template>
    </p-table>
    </td>
    </tr>
    @if(itemData?.data?.length) {
    <tr style="background: #fff !important;">
      <td [attr.colspan]="columns.length + 1">
        <p-table [value]="itemData?.data" styleClass="line-item-table">
          <ng-template pTemplate="header">
    <tr>
      <th style="text-wrap: nowrap; padding-left: 20px !important; color: red !important;">
        <strong>{{itemData?.header}}</strong>
      </th>
    </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td style="white-space: nowrap; padding-left: 20px !important; color: red !important;">
          {{ item }}
        </td>
      </tr>
    </ng-template>
    </p-table>
    </td>
    </tr>
    }
    }


    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns?.length + 1" style="text-align: center;font-weight: 700;">
          <div tabindex="0" aria-label="No Record Found">
            No Record Found
          </div>
        </td>
      </tr>

    </ng-template>

    </p-table>

  </div>
</div>



<ppl-popup-dialog [(isVisible)]="show" [title]="'Custom Search'" [showButtons]="true" [showOkButton]="false"
  [showButtonIcons]="false" [position]="'center'" [size]="'large'" [isOkText]="'Apply'" [rightAlignedButtons]="true"
  (confirm)="applyFilter()" (cancel)="clearNotApplicableFilterRules(); filterError='' ; show = false">

  <div class="overlay-content">
    <div style="display: flex; justify-content: space-between;">
      <h2 class="header-text" id="condition-label" [attr.aria-label]="'Custom Search Condition'">Condition</h2>
      <!-- <i class="pi pi-times close-icon ppl-pointer" (click)="clearNotApplicableFilterRules();filterError='' ; show = false"></i> -->
    </div>
    <div class="condition-dropdown-container">
      <nz-radio-group class="ppl-radio-group" id="gender" pplSelectedRadioFocus
             role="radiogroup" aria-labelledby="condition-label" name="categorty" [(ngModel)]="condition">
              @for(opt of conditionType; track $index){
              <label nz-radio [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
    </div>
    <div style="display:flex; justify-content: space-between;">
      <h3 class="header-text">Enter filter parameter</h3>
      <button type="button" pButton (click)="clearAllFilters()" aria-label="Clear all filters" icon="pi pi-filter-slash"
        class="delete-btn" style="margin-bottom: 4px;">
        &nbsp;&nbsp; Clear all filters</button>
    </div>
    <div>
      @for (rule of filterRules; track rule; let idx = $index ) {
      <div class="filter-manger ant-form" [class.test]="idx === 0">
        <!-- <p-dropdown [optionLabel]="'header_label'" [optionValue]="'jsonpath'" [ngClass]="rule.column === '' && filterError ? 'error-input' : 'valid'"
              [options]="getAvailableColumn()" [optionDisabled]="'disabled'" #dropdownValue
              [(ngModel)]="rule.column" placeholder="Select Column">
            </p-dropdown> -->
        <div [ngClass]="{'error': getErrorStatus(rule.column === '' && filterError) }">
        <ppl-dropdown-select [setPanelHeight]="true" [(ngModel)]="rule.column" [arialabel]="'Select Custom Search Parameter ' + (idx + 1)" class="ppl-select"
        [options]="getAvailableColumn()" [optionLabel]="'header_label'" [optionValue]="'jsonpath'"
        placeholder="Select Column" (selectionChange)="updateFilterTypes(rule)"></ppl-dropdown-select>
      </div>

      <div [ngClass]="{'error': getErrorStatus(rule.filtertype === '' && filterError)}">
        <ppl-dropdown-select [setPanelHeight]="true" [(ngModel)]="rule.filtertype" pplNzAriaLabel nzAriaLabel="Select Filter Type" class="ppl-select"
        [options]="rule.filterTypes" [optionLabel]="'label'" [optionValue]="'value'"
        placeholder="Select Filter Type" (selectionChange)="operatorChange(rule)"></ppl-dropdown-select>
      </div>

      @if(rule.customSearchType === 'dropdown') {
        <nz-select [(ngModel)]="rule.value" class="ppl-select" nzPlaceHolder="Select Value"
          [nzStatus]="getErrorStatus(rule.value === '' && filterError)" [disabled]="rule.disableValue"
          nzShowSearch nzAllowClear>
          @for(opt of getDropdownValues(rule); track $index){
          <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
          }
        </nz-select>
      } @else if(rule.customSearchType === 'number') {
        <input nz-input [(ngModel)]="rule.value" inputmode="numeric" placeholder="Enter number of days"
          [nzStatus]="getErrorStatus(rule.value === '' && filterError)" [disabled]="rule.disableValue"
          (input)="onNumericInput(rule, $event)" />
      } @else {
        <input nz-input [(ngModel)]="rule.value" placeholder="Enter Value"
          [nzStatus]="getErrorStatus(rule.value === '' && filterError)" [disabled]="rule.disableValue" />
      }
        <!-- <p-button (onClick)="removeRule(idx, $any(dropdownValue.value))" icon="pi pi-trash" class="hammer-btn"></p-button>
            <p-button (onClick)="addRule()" icon="pi pi-plus"></p-button> -->
        <button aria-label="Remove rule" type="button" pButton (click)="removeRule(idx)" icon="pi pi-trash"
          class="delete-btn"></button>
        <button aria-label="Add rule" type="button" pButton (click)="addRule()" icon="pi pi-plus"
          class="delete-btn"></button>
      </div>
      }
    </div>

    <div>
      <h3 class="header-text">Sort By</h3>
      <div class="sortBy ant-form">
          <ppl-dropdown-select [setPanelHeight]="true" [(ngModel)]="columnName" pplNzAriaLabel nzAriaLabel="Column Name" class="ppl-select"
          [options]="getAvailableColumnForSort()" [optionLabel]="'header_label'" [optionValue]="'jsonpath'"
          placeholder="Column Name"></ppl-dropdown-select>

          <div [ngClass]="{'error': getErrorStatus(showSortByError && filterError)}">
          <ppl-dropdown-select [setPanelHeight]="true" [(ngModel)]="sortBy" pplNzAriaLabel nzAriaLabel="Sort by Ascending or Descending" class="ppl-select"
          [options]="sortByOptions" [optionLabel]="'label'" [optionValue]="'value'"
          placeholder="Select Sort By"></ppl-dropdown-select>
        </div>

        <!-- <p-dropdown [optionLabel]="'header_label'" [optionValue]="'jsonpath'" [(ngModel)]="columnName"
              [options]="getAvailableColumn()" placeholder="Column Name">
            </p-dropdown> -->
        <!-- <p-dropdown [options]="sortByOptions" [(ngModel)]="sortBy" placeholder="Select Sort By">
            </p-dropdown> -->
      </div>
    </div>

    <div class="filter-error">
      <span class="text-danger" *ngIf="filterError">{{filterError}}</span>
    </div>

  </div>

</ppl-popup-dialog>
<!-- <p-overlayPanel class="overlay" #filterpanel [dismissable]="false">
  
</p-overlayPanel> -->
<!-- <ppl-notification-sms [show]="showSMSModal" (onHandleCancel)="onHandleCancel($event)" [notificationType]="notificationType"
[sourcePage]="jsonList" [selectedCheckBoxValue]="selectedCheckBoxValue"></ppl-notification-sms> -->